
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/bigcommerce",
      function () {
        return require("private-next-pages/destinations/bigcommerce.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/bigcommerce"])
      });
    }
  